package co.maytes.standupbot.dashboard.features.settings

import co.maytes.standupbot.shared.dto.auth.RoleDto
import co.maytes.standupbot.shared.dto.workspace.WorkspaceMemberDto

object MemberDialogCopy {
    fun disable(member: WorkspaceMemberDto): String =
        "${member.displayName} will be signed out everywhere and can't use StandupBot until you restore them. " +
            "They're removed from every standup roster, and their past updates stay in the history."

    fun restore(member: WorkspaceMemberDto): String =
        "${member.displayName} can sign in again as ${roleLabel(member.role)}. " +
            "They aren't added back to any standup automatically."

    fun erase(member: WorkspaceMemberDto): String =
        "This permanently removes ${member.displayName}'s name, email, avatar and linked Slack, Linear and GitHub " +
            "accounts. Their past updates stay and show \"Former member\". This can't be undone."

    fun transfer(
        member: WorkspaceMemberDto,
        workspaceName: String,
    ): String =
        "${member.displayName} becomes the owner of $workspaceName. You become an Admin and can't undo this " +
            "yourself. You'll both get a Slack message."

    private fun roleLabel(role: RoleDto): String =
        when (role) {
            RoleDto.OWNER -> "an Owner"
            RoleDto.ADMIN -> "an Admin"
            RoleDto.MEMBER -> "a Member"
            RoleDto.VIEWER -> "a Viewer"
        }
}
